<template>
  <v-container fluid grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
          <h4>Отчет</h4>
      </v-flex>
      <v-flex xs12>
        <v-tabs>
          <v-tab href="#tab-1">
            Основные данные
          </v-tab>
          <v-tab-item
                  :value="'tab-1'">
            <v-card>
<!--              <v-card-text>-->
                <v-container grid-list-md class="py-1">
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                        <v-menu
                                ref="menuFilter"
                                v-model="menuFilter"
                                :close-on-content-click="false"
                                :return-value.sync="report.period"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                        :value="computedDateFormattedMomentjs"
                                        label="Период"
                                        prepend-icon="mdi-calendar-month"
                                        readonly
                                        v-on="on"
                                        :error-messages="requiredErrors('period')"
                                        @blur="$v.report.period.$touch()"
                                        :disabled="disableReport"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                    v-model="report.period"
                                    type="month"
                                    no-title
                                    scrollable
                                    @input="savePeriod"
                            >
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                        Статус: {{ getStatus(report.status) }}
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                              v-model.trim="report.remark"
                              label="Замечание"
                              rows="2"
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                        <component
                                v-bind:is="componentData"
                                :data-report="report.data"
                                :disable-report="disableReport"
                                ref="childComponent"
                        >
                        </component>
                    </v-flex>
                  </v-layout>
                </v-container>
<!--              </v-card-text>-->
            </v-card>
          </v-tab-item>
            <v-tab href="#tab-2">
                Системные данные
            </v-tab>
            <v-tab-item
                    :value="'tab-2'">
                <system-form :system-info=report></system-form>
            </v-tab-item>
        </v-tabs>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                      v-if="[1, 2, 4].includes(report.status) && report.self_department"
                      @click.native="save(1)">Сохранить как черновик
              </v-btn>
              <v-btn
                      v-if="[1, 2].includes(report.status) && report.self_department"
                      @click.native="save(2)">Отправить на проверку
              </v-btn>
              <v-btn
                      v-if="[2, 3].includes(report.status) && isManager"
                      @click.native="save(4)">Отправить на доработку
              </v-btn>
              <v-btn
                      v-if="[2, 4].includes(report.status) && isManager"
                      @click.native="save(3)">Принять отчёт
              </v-btn>
              <v-btn
                      v-if="!this.disableReport && this.$route.params.report_id !== 'new'"
                      @click.native="del">Удалить
              </v-btn>
              <v-btn
                      v-if="[1].includes(report.status) && this.$route.params.report_id !== 'new' && isManager"
                      @click.native="summary">Собрать данные
              </v-btn>
              <v-btn @click.native="cancel">Отменить
              </v-btn>
          </v-card-actions>
      </v-flex>
        <v-flex xs12 md8>
            <router-view></router-view>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import SystemForm from '../common/systemForm'
import moment from 'moment'

export default {
  components: { SystemForm },
  data () {
    return {
      menuFilter: false
    }
  },
  mixins: [validationMixin],
  validations: {
    report: {
      period: { required }
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    report () {
      return this.$store.getters['reportingReport/report']
    },
    componentData () {
      // return () => import('./dataForms/monitoring_msss_02.vue')
      return () => import('@/components/reporting/dataForms/' + this.$route.params.typeAbbr + '.vue')
      // return () => import(`@/components/reporting/dataForms/${ this.$route.params.typeAbbr }.vue`)
    },
    computedDateFormattedMomentjs () {
      return this.report.period ? moment(this.report.period).format('MMMM YYYY') : ''
    },
    statuses () {
      return this.$store.getters['reportingReport/statuses']
    },
    disableReport () {
      return !(this.getStatus(this.report.status) === 'Черновик' && this.report.self_department)
    },
    user () {
      return this.$store.getters['auth/user']
    },
    isManager () {
      return this.user.groups.includes(this.getType(this.$route.params.typeAbbr).manager_group)
    }
  },
  methods: {
    initialize () {
      let id = this.$route.params.report_id
      if (id === 'new') {
        this.$store.commit('reportingReport/setDefaultReport', { typeAbbr: this.$route.params.typeAbbr })
      } else {
        this.$store.dispatch('reportingReport/fetchReport', {
          id: id })
      }
    },
    savePeriod (period) {
      this.$refs.menuFilter.save(this.report.period)
      // this.$refs.picker.activePicker = 'MONTH'
      this.menuFilter = true
      // this.pagination.page = 1
      // this.paginationExportFiles.page = 1
      // this.initializeListFiles()
      // this.initializeExportListFiles()
    },
    getStatus (id) {
      return this.$store.getters['reportingReport/getStatus'](id)
    },
    getType (typeAbbr) {
      return this.$store.getters['reportingReport/getType'](typeAbbr)
    },
    save (statusId) {
      this.$v.$touch()
      if (!this.$v.$invalid && this.componentValid()) {
        this.$set(this.report, 'status', statusId)
        this.$store.dispatch('reportingReport/insertReport', this.report)
          .then(() => {
            if (this.$route.params.report_id === 'new') {
              this.$router.push({
                name: 'reporting_report',
                params: {
                  // typeAbbr: this.report.typeAbbr,
                  report_id: this.report.id
                }
              })
            }
          }
          )
      }
    },
    requiredErrors (fieldName) {
      const errors = []
      const field = this.$v.report[fieldName]
      if (!field.$dirty) return errors
      if (field.hasOwnProperty('required')) {
        !field.required && errors.push('Обязательное поле')
      }
      return errors
    },
    del () {
      if (this.report.id !== 'new') {
        this.$store.dispatch('reportingReport/deleteReport', this.report.id)
          .then(() => {
            this.$router.push({ name: 'reporting_list' })
          })
      }
    },
    summary () {
      if (this.report.id !== 'new') {
        this.$store.dispatch('reportingReport/summaryReport', this.report.id)
      }
    },
    cancel () {
      this.$router.push({ name: 'reporting_list' })
    },
    componentValid () {
      // Запуск валидации формы вложенного компонента
      try {
        return this.$refs.childComponent.$refs.form.validate()
      } catch (e) {
        return true
      }
    }
  },
  created: function () {
    this.initialize()
  }
}
</script>
<style scoped>
  td, th {
    text-align: left;
    padding: 5px;
  }
  th {
    vertical-align: top
  }
  .bloc_inline
  {
    display:inline-block;
  }
</style>
